import { __assign, __rest } from "tslib";
import * as React from 'react';
import { StylesConsumer } from '../../contexts/StylesContext';
import { SDKAdapterConsumer } from '../../contexts/SDKAdapterContext';
import { BaseFontAndColorPicker } from './BaseFontAndColorPicker';
function validateFontSize(nextSize, limits) {
    if (limits.maxSize && nextSize > limits.maxSize) {
        return limits.maxSize;
    }
    if (limits.minSize && nextSize < limits.minSize) {
        return limits.minSize;
    }
    return nextSize;
}
export var FontAndColorPicker = function (props) {
    function handleColorChange(color) {
        var _a = props.value.font, _ = _a.value, font = __rest(_a, ["value"]);
        var newFont = font;
        var htmlTag = newFont.htmlTag;
        if (props.onChange) {
            props.onChange({
                font: newFont,
                color: color,
                htmlTag: htmlTag,
            });
        }
        if (props.onColorChange) {
            props.onColorChange(color);
        }
    }
    function handleFontChange(_a) {
        var _ = _a.value, font = __rest(_a, ["value"]);
        var nextSize = font.size;
        var maxSize = props.fontPickerOptions.fontMaxSize;
        var minSize = props.fontPickerOptions.fontMinSize;
        var newFont = __assign(__assign({}, font), { 
            // Do not allow to override font size from presets, always take into account min/max values
            size: validateFontSize(nextSize, { maxSize: maxSize, minSize: minSize }) });
        var htmlTag = newFont.htmlTag;
        if (props.onChange) {
            props.onChange({
                color: props.value.color,
                font: newFont,
                htmlTag: htmlTag,
            });
        }
        if (props.onFontChange) {
            props.onFontChange(newFont);
        }
        if (props.onHtmlTagChange && props.fontPickerOptions.showHTMLTag) {
            props.onHtmlTagChange(htmlTag);
        }
    }
    var _a = props.value || {}, color = _a.color, font = _a.font, htmlTag = _a.htmlTag;
    var fontWithHtmlTag = font;
    if (htmlTag) {
        fontWithHtmlTag = __assign(__assign({}, font), { htmlTag: htmlTag });
    }
    return (React.createElement(SDKAdapterConsumer, null, function (_a) {
        var SDKAdapter = _a.SDKAdapter;
        return (React.createElement(StylesConsumer, null, function (styles) {
            var _a;
            return (React.createElement(BaseFontAndColorPicker, { SDKAdapter: SDKAdapter, label: props.title, fontPickerTitle: props.panelTitle, customFontLabel: props.customFontLabel, font: fontWithHtmlTag, color: color, onColorChange: handleColorChange, onSiteColorsChange: function (palette) {
                    styles.changeSiteColors(palette);
                }, onFontChange: handleFontChange, fontPickerOptions: (_a = props.fontPickerOptions) !== null && _a !== void 0 ? _a : {}, dataHook: props.dataHook }));
        }));
    }));
};
//# sourceMappingURL=FontAndColorPicker.js.map